var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('h2',[_vm._v("Redirigiendose a APS Virtual ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }